import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api';
import DashboardLayout from '../../Components/Dashboard/DashboardLayout';
import './AdminDashboardPage.css';

const AdminDashboardPage = () => {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await api.get('/admin/dashboard/metrics');
    setMetrics(res.data);
  };

  if (!metrics) return <DashboardLayout>Loading...</DashboardLayout>;

  const cards = [
    ['Total students', metrics.total_students, '👥'],
    ['Total courses', metrics.total_courses, '📚'],
    ['Pending enrollments', metrics.pending_enrollments, '⏳'],
    ['Approved enrollments', metrics.approved_enrollments, '✅'],
    ['Certificates issued', metrics.certificates_issued, '🎓'],
    ['Revenue estimate', metrics.revenue_estimate, '💰'],
  ];

  return (
    <DashboardLayout>
      <div className="container py-4 lms-admin-shell">
        <div className="lms-admin-header mb-4">
          <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
            <div>
              <h3 className="mb-1">LMS Admin Dashboard</h3>
              <p className="mb-0 opacity-75">Manage courses, intakes, enrollment approvals, and growth.</p>
            </div>
            <div className="d-flex gap-2">
              <Link className="btn btn-light btn-sm" to="/admin/courses/create">
                + New course
              </Link>
              <Link className="btn btn-outline-light btn-sm" to="/admin/lms-enrollments">
                Review enrollments
              </Link>
            </div>
          </div>
        </div>

        <div className="row g-3">
          {cards.map(([title, value, icon]) => (
            <div className="col-md-6 col-xl-4" key={title}>
              <div className="card lms-stat-card p-3">
                <div className="d-flex justify-content-between align-items-center mb-1">
                  <span className="lms-stat-label">{title}</span>
                  <span>{icon}</span>
                </div>
                <div className="lms-stat-value">{value}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="row g-3 mt-1">
          <div className="col-lg-8">
            <div className="card lms-quick-card p-4 h-100">
              <h5 className="mb-3">Enrollment overview</h5>
              <div className="d-flex flex-wrap gap-2 mb-3">
                <span className="lms-pill lms-pill-warning">Pending: {metrics.pending_enrollments}</span>
                <span className="lms-pill lms-pill-success">Approved: {metrics.approved_enrollments}</span>
              </div>
              <p className="text-muted mb-0">
                Monitor intake demand and approve payments promptly to maintain student onboarding speed.
              </p>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="card lms-quick-card p-4 h-100">
              <h5 className="mb-3">Quick actions</h5>
              <div className="d-grid gap-2">
                <Link className="btn btn-primary btn-sm" to="/admin/courses/create">
                  Create course + intakes
                </Link>
                <Link className="btn btn-outline-primary btn-sm" to="/admin/courses">
                  Manage courses
                </Link>
                <Link className="btn btn-outline-primary btn-sm" to="/articles/new">
                  Create article
                </Link>
                <Link className="btn btn-outline-primary btn-sm" to="/gallery-admin">
                  Add gallery image
                </Link>
                <Link className="btn btn-outline-secondary btn-sm" to="/admin/lms-enrollments">
                  Verify payments
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AdminDashboardPage;
